import HintButton from './HintButton';

export default HintButton;
